export default __webpack_public_path__ + "static/media/a2-4-3.7e4e5fda.jpg";